import { render } from "./Tolbar.vue?vue&type=template&id=a921593e&scoped=true"
import script from "./Tolbar.vue?vue&type=script&lang=js"
export * from "./Tolbar.vue?vue&type=script&lang=js"

import "./Tolbar.vue?vue&type=style&index=0&id=a921593e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a921593e"]])

export default __exports__